<template>
  <schedule-overlay-container :isOpen="open" :isLoading="loading">
    <template #header>
      <div v-for="(column, index) of columns"
           :key="index"
           class="statistics-overlay__header__column">
        <span>{{ column }}</span>
      </div>
      <div class="statistics-overlay__header--end">
        <day-select-dropdown :selectedDate="loadStatisticsStartDate" @date-selected="(value) => setLoadStatisticsStartDate(value)" mode="day">
          <template #trigger="{ toggleDropdown, selectedDate }">
            <a
              tooltiptext
              tabindex="0"
              class="this-week-button test-this-week control-button"
              @click="toggleDropdown"
            >
              <span class>
                <span v-if="(selectedDate)" class="control-button-text">Fra {{ formatDate(selectedDate) }}</span>
              </span>
            </a>
          </template>
        </day-select-dropdown>
        <day-select-dropdown :selectedDate="loadStatisticsEndDate" @date-selected="(value) => setLoadStatisticsEndDate(value)" mode="day">
          <template #trigger="{ toggleDropdown, selectedDate }">
            <a
              tooltiptext
              tabindex="0"
              class="this-week-button test-this-week control-button"
              @click="toggleDropdown"
            >
              <span class>
                <span v-if="(selectedDate)" class="control-button-text">Til {{ formatDate(selectedDate) }}</span>
              </span>
            </a>
          </template>
        </day-select-dropdown>
        <span v-if="editingControls">
          <a class="control-button is-active">Redigér skabelonen</a>
        </span>
      </div>
    </template>
    <template #body>
      <div v-for="(row, index) of employeeStatistics"
           :key="index"
           class="statistics-overlay__row">
        <div :class="['statistics-overlay__row__category', row.category, 'color']">

        </div>
        <div class="statistics-overlay__row__label">
          <span>{{ row.employee.number }} - {{ row.employee.name }}</span>
        </div>
        <div class="statistics-overlay__row__total">
          <span>{{ row.allocations.total }}</span>
        </div>
        <div class="statistics-overlay__row__cell">
          <span>{{ row.allocations.work }}</span>
        </div>
        <div class="statistics-overlay__row__cell">
          <span>{{ row.allocations.saturday }}</span>
        </div>
        <div class="statistics-overlay__row__cell">
          <span>{{ row.allocations.sunday }}</span>
        </div>
        <div class="statistics-overlay__row__cell">
          <span>{{ row.allocations.holiday }}</span>
        </div>
        <div class="statistics-overlay__row__cell">
          <span>{{ row.allocations.vacation }}</span>
        </div>
        <div class="statistics-overlay__row__cell">
          <span>{{ row.allocations.standIn }}</span>
        </div>
        <div class="statistics-overlay__row__cell">
          <span>{{ row.allocations.other }}</span>
        </div>
        <div class="statistics-overlay__row__cell">
          <span>{{ row.allocations.free }}</span>
        </div>
        <div class="statistics-overlay__row__cell">
          <span>{{ row.allocations.timeOff }}</span>
        </div>
        <div class="statistics-overlay__row__cell">
          <span>{{ row.availableDays }}</span>
        </div>
      </div>
    </template>
  </schedule-overlay-container>
</template>

<script>
import ScheduleOverlayContainer from '../../common/ScheduleOverlayContainer.vue';
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';
import DaySelectDropdown from '@/components/common/DaySelectDropdown.vue';
import ApiState from '@/enums/APISTATE';

export default {
  name: 'statistics-overlay',
  components: { ScheduleOverlayContainer, DaySelectDropdown },
  props: {
    editingControls: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    open: false,
    columns: ['Hverdage', 'Lørdage', 'Søndage', 'Helligdage', 'Ferie', 'Bagvagt', 'Andet', 'Fri', 'Afspadsering',"Tilgængelige dage"],
    rows: [],

  }),
  mounted() {

  },
  methods: {
    ...mapActions("statisticsStore", ["setLoadStatisticsStartDate", "setLoadStatisticsEndDate"]),
    formatDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    toggle() {
      this.open = !this.open;
      return this.open;
    },

  },
  computed:  {    
    ...mapGetters('scheduler', ['allocations', 'groups', 'employees']),
    ...mapGetters("holidayStore", ["holidaysApiState", "holidays"]),
    ...mapGetters("statisticsStore", ["employeeStatistics", "statisticsApiState", "loadStatisticsStartDate", "loadStatisticsEndDate"]),
    loading() {
      return ApiState.LOADING === this.statisticsApiState;
    },

  }
}
</script>

<style lang="scss">
.timeline-view {
  padding-bottom: 200px;
}

.schedule-overlay-container__header {
  display: flex;
  flex-flow: row nowrap;

  .statistics-overlay__header__column {
    flex: 0 0 94px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    border-right: 2px solid $panel;
    height: 100%;
    padding: 0 10px;

    span {
      color: white;
      font-size: 12px;
    }
  }
  .statistics-overlay__header--end {
    flex: 1 0 auto;
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-end;
    align-items: center;
    padding-right:20px;
    gap: 10px;

    a {
      padding: 0 20px;
    }
  }
}

.schedule-overlay-container {
  .statistics-overlay__row {
    display: flex;
    flex-flow: row nowrap;
    border-bottom: 2px solid $panel;

    div:not(:first-child) {
      border-right: 2px solid $panel;
    }
    div {
      font-size: 13px;
      display: flex;
      padding: 8px 10px 8px 20px;

      &.statistics-overlay__row__category {
        flex: 0 0 5px;
        padding: 2px;
      }
      &.statistics-overlay__row__label {
        flex: 0 0 316px;
        font-weight: 600;
      }
      &.statistics-overlay__row__total {
        flex: 0 0 99px;
        justify-content: flex-end;
      }
      &.statistics-overlay__row__cell {
        flex: 0 0 94px;
        justify-content: flex-end;
      }
    }
  }
}
</style>
